import React from 'react'

const InputCom = React.forwardRef(
  (
    {
      label,
      type = 'text',
      name,
      placeholder,
      children,
      inputHandler,
      value,
      inputClasses = '',
      labelClasses = 'text-qgray text-[13px] font-normal',
      readOnly,
      loading = false,
      ...rest
    },
    ref
  ) => {
    return (
      <div className="input-com w-full h-full">
        {label && (
          <label
            className={`input-label capitalize block mb-2 ${labelClasses}`}
            htmlFor={name}
          >
            {label}
          </label>
        )}
        <div className="input-wrapper border border-qgray-border w-full h-full overflow-hidden relative">
          <input
            type={type}
            id={name}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={inputHandler}
            readOnly={readOnly}
            ref={ref} // <-- important for React Hook Form
            className={`input-field placeholder:text-sm text-sm px-6 text-dark-gray w-full font-normal bg-white focus:ring-0 focus:outline-none ${inputClasses}`}
            {...rest} // <-- allows register() props like onBlur, onChange, etc.
          />
          {loading && (
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-purple-600"></div>
            </div>
          )}
          {children}
        </div>
      </div>
    )
  }
)

export default InputCom
